export const REQUEST_STATUS_MAP: { [key: string]: { label: string; class: string } } = {
  N: { label: "New", class: "badge-info" },
  T: { label: "To Be Approved", class: "badge-warning" },
  P: { label: "Partially Approved", class: "badge-warning" },
  A: { label: "Approved", class: "badge-success" },
  R: { label: "Rejected", class: "badge-danger" },
  D: { label: "Processing Complete", class: "badge-success" },
  X: { label: "Deleted", class: "badge-danger" },
  B: { label: "To Be Processed", class: "badge-warning" },
  C: { label: "Closed", class: "badge-secondary" },
  K: { label: "Cancelled", class: "badge-danger" },
  S: { label: "Settled", class: "badge-success" },
};

export const REQUEST_STATUS_OPTIONS = [
  { value: "N", label: "New" },
  { value: "T", label: "To Be Approved" },
  { value: "P", label: "Partially Approved" },
  { value: "B", label: "To Be Processed" },
  { value: "A", label: "Approved" },
  { value: "R", label: "Rejected" },
  { value: "D", label: "Processing Complete" },
];
